import axios from "axios";
import store from "../../../../../stores/application/index.js.erb";

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

const StudyEstEukTechMapAdditDataApiService = {
    async index() {
        get_token();
        try {
            return await axios.get('/study/study_est_euk_tech_map_addit_data');
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async show(params) {
        get_token();
        try {
            return await axios.get(
                '/study/study_est_euk_tech_map_addit_data/:id',
                { params }
        );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async get_hours_plan(params) {
        get_token();
        try {
            return await axios.get(
                '/study/study_est_euk_tech_map_addit_data/get_hours_plan',
                { params }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async get_disciplines(params) {
        get_token();
        try {
            return await axios.get(
                '/study/study_est_euk_tech_map_addit_data/get_disciplines',
                { params: params }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async get_semesters(params) {
        get_token();
        try {
            return await axios.get(
                '/study/study_est_euk_tech_map_addit_data/get_semesters',
                { params }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async get_count_tech_maps() {
        get_token();
        try {
            return await axios.get(
                '/study/study_est_euk_tech_map_addit_data/get_count_tech_maps',
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async get_study_years() {
        get_token();
        try {
            return await axios.get(
                '/study/study_est_euk_tech_map_addit_data/get_study_years',
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },

}

export default StudyEstEukTechMapAdditDataApiService;